import yup from "src/validators/yup.Module";

export interface TributacaoMensagemCadastroDto {
  id?: number;
  mensagem: string;
  padrao?: boolean;
}

export const TributacaoMensagemCadastroSchema = yup.object().shape({
  mensagem: yup
    .string()
    .required("A mensagem é obrigatória")
    .min(3, "A mensagem deve ter no mínimo 3 caracteres"),
  padrao: yup.boolean().notRequired(),
});
